import GuidePayment from './GuidePayment';
import PaymentSuccess from './GuidePaymentSuccess';
import PaymentFailure from './GuidePaymentFailure';

export default GuidePayment;
export {
  PaymentSuccess,
  PaymentFailure,
};

